export const SETTINGS = {
    draggable: true,
    slidesToShow: 6,
}
